export default __webpack_public_path__ + "pgnv-assets/b367260b2f2a58d8c51d45d743270a0a.png";